import React, { Component } from 'react'

import TestOption from './TestOption'
import IconRender from '../std/IconRender';

class TestOptions extends Component {

	handleOptionChange(data, index) {
		var list = [];
		for (var key in this.props.data) {
			var occ = this.props.data[key];
			if (key - index === 0) {
				list.push(data);
			} else {
				list.push(occ);
			}
		}
		this.props.onChangeOptions(list);
	}
	handleOptionDelete(code) {
		var list = [];
		for (var key in this.props.data) {
			var occ = this.props.data[key];
			if (occ.code !== code) {
				list.push(occ);
			}
		}
		this.props.onChangeOptions(list);
	}
	handleOptionCopy(code) {
		var list = this.props.data != null ? [...this.props.data] : [];
		var occCopy = null;
		var indexSuffix = list.length + 1;
		for (var key in this.props.data) {
			var occ = this.props.data[key];
			if (occ.code === code) {
				occCopy = { ...occ };
			}
			if (occ.code === `option${indexSuffix}`) {
				indexSuffix++;
			}
		}
		if(occCopy != null){
			occCopy.code = `option${indexSuffix}`;
			list.push(occCopy);
			this.props.onChangeOptions(list);
		}
	}
	handleOptionAdd() {
		var list = this.props.data != null ? [...this.props.data] : [];
		var size = list.length + 1;
		list.push({ code: `option${size}`, pricing: {} });
		this.props.onChangeOptions(list);
	}

	render() {
		return (
			<div className="row">
				{this.props.data && this.props.data.map((occurence, index) => (
					<div key={index} className="row shadow-sm m-1 p-1">
						<TestOption data={occurence} settings={this.props.settings} onChange={(data) => { this.handleOptionChange(data, index) }} />
						<div className="col-auto">
							<button className="btn btn-light" onClick={() => this.handleOptionDelete(occurence.code)} >
								<IconRender name="trash" />
							</button>
						</div>
						<div className="col-auto">
							<button className="btn btn-light" onClick={() => this.handleOptionCopy(occurence.code)} >
								<IconRender name="stickies" />
							</button>
						</div>
					</div>
				))}
				<div className="col-auto">
					<button className="btn btn-light" onClick={() => this.handleOptionAdd()} >
						<IconRender name="plus" />
					</button>
				</div>
			</div>
		)
	}
}

export default (TestOptions)
